import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProcessingPage.css';

function ProcessingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/success'); // Goes directly to combined SuccessPage
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="processing-page">
      <div className="container">
        <div className="processing-content">
          <div className="spinner"></div>
          <h2>Processing Your Information</h2>
          <p>Please wait while we process your loan application...</p>
          <div className="processing-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessingPage;